import { ServiceCategory } from 'src/types';
import css from './category-filter.module.scss';
import { useGetServiceCategories } from './api/queries';
import { SERVICES_ROUTES, VETERAN_LOCATIONS } from 'src/constants/routes';
import { useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

interface ServiceCategoryFilterProps {
  selectedCategory?: string;
}

export default function ServiceCategoryFilter({ selectedCategory }: Readonly<ServiceCategoryFilterProps>) {
  const myRef = useRef<[] | HTMLAnchorElement[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  const { data: categories = [] } = useGetServiceCategories();

  const scroll = useCallback((idx: number) => {
    const el = containerRef.current?.getBoundingClientRect();
    const isVisible =
      el &&
      el.top >= -100 &&
      el.left >= 0 &&
      el.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      el.right <= (window.innerWidth || document.documentElement.clientWidth);

    isVisible && myRef.current[idx]?.scrollIntoView({ behavior: 'auto', block: 'nearest' });
  }, []);

  const getRoute = (name: string) => SERVICES_ROUTES.find((r) => r.title === name)?.path ?? null;

  useEffect(() => {
    scroll(categories.map((i: ServiceCategory) => i.id).indexOf(selectedCategory));
  }, [categories, scroll, selectedCategory]);

  return (
    <div className={css.categoryFilter}>
      <div className={css.filterBtns} ref={containerRef}>
        {categories
          .filter((c: ServiceCategory) => c.name !== VETERAN_LOCATIONS.title)
          .map((category: ServiceCategory, i: number) => (
            <Link
              ref={(el: HTMLAnchorElement) => (myRef.current[i] = el)}
              to={getRoute(category.name) ?? `/services/${category.slug}`}
              className={selectedCategory === category.id ? css.active : ''}
              key={category.name}>
              <span>{category.name}</span>
            </Link>
          ))}
      </div>
    </div>
  );
}
